<template>
  <div class="product_info">
    <div class="product_info_top">
      <div class="left_cover" :style="coverInfo">
        <img :style='coverInfo' :src='content.cover' />
      </div>
      <div class="right_info">
        <div class="titles">{{content.title}}</div>
        <div class="price">¥{{content.price}}</div>
        <div class="time">{{content.time}}</div>
      </div>
    </div>
    <div class="product_info_bottom">
      所属店铺: {{ content.shop_name }}
    </div>
    
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => {},
    },
    coverInfo: {
      type: String,
      default: "width: 110px;height: 82px;",
    },
    paddingleft: {
      type: String,
      default: "padding-left: 120px;",
    },
  },
};
</script>
<style lang="less" scoped>
.product_info {
  width: 100%;
  .product_info_top{
    .left_cover {
      width: 82px;
      height: 82px;
      // background: #67a6ff;
      border-radius: 6px;
      position: relative;
      margin-right: 10px;
      float: left;
    }

    .left_cover img {
      width: 82px;
      height: 82px;
      border-radius: 6px;
      display: block;
    }

    .right_info {
      width: 100%;
      height: 100%;
      padding-left: 100px;
      box-sizing: border-box;
      text-align: left;
      color: #676c7e;

      .titles {
        width: 100%;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 10px;
      }

      .price {
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        color: red;
        margin-bottom: 12px;
      }

      .time {
        font-size: 14px;
        font-weight: 400;
        color: #7d7f95;
      }
    }
  }
  .product_info_bottom{
    margin-top: 4px;
    font-size: 12px;
    color: #727272;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
}
</style>

